import { render, staticRenderFns } from "./AddNewOrg.vue?vue&type=template&id=555e5b5e&scoped=true&"
import script from "./AddNewOrg.vue?vue&type=script&lang=js&"
export * from "./AddNewOrg.vue?vue&type=script&lang=js&"
import style0 from "./AddNewOrg.vue?vue&type=style&index=0&id=555e5b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e5b5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepper,VStepperContent,VStepperHeader,VStepperItems,VStepperStep})
